// Short form version of restaurants.js
const restaurants = {
  rubirosa: {
    name: "Rubirosa Ristorante",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://goo.gl/maps/AxMj5W2ptLqd3oyZ6",
    rating: "9",
    price: "1",
    style: "Italian",
    lastVisited: "2021-04-17",
    text: "Thin crust pizza, the best in NYC",
    times: "5",
  },
  upsidepizza: {
    name: "Upside Pizza",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://goo.gl/maps/Zz48qH8EN5L6WCT3A",
    rating: "5",
    price: "0",
    style: "Italian",
    lastVisited: "2021-05-28",
    text: "Sourdough crusted thick pizza",
    video: "https://www.youtube.com/watch?v=cTW1T3GAH_s?t=20",
    times: "1",
  },
  foxface: {
    name: "Foxface",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://g.page/foxface?share",
    rating: "7",
    price: "1",
    style: "American",
    times: "1",
    text: "Smoky, meaty, delicious sandwiches",
  },
  bessou: {
    name: "Bessou",
    location: "New York City",
    district: "Noho",
    googleMaps: "https://goo.gl/maps/U5CZPHuTqjjk2ygUA",
    rating: "8",
    price: "1",
    style: "Japanese",
    text: "Japanese comfort food and super crispy fried chicken",
    video: "https://www.youtube.com/watch?v=dGeIla4Smoc",
    times: "4",
  },
  brotherjimmys: {
    name: "Brother Jimmys",
    location: "New York City",
    district: "Murray Hill",
    googleMaps: "https://g.page/brotherjimmysnyc?share",
    rating: "5",
    price: "1",
    style: "American",
    text: "BBQ, would rec fish bowl and brisket",
    times: "1",
  },
  chachantang: {
    name: "Cha Chan Tang",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/TncHwxs5GfTm94UJ6",
    rating: "7",
    price: "0",
    style: "Chinese",
    text: "Eastern taken on Western food",
    times: "4",
  },
  cote: {
    name: "Cote",
    location: "New York City",
    district: "Flatiron",
    googleMaps: "https://g.page/cote_nyc?share",
    rating: "9",
    price: "4",
    style: "Korean",
    text: "Highroll kbbq, would rec the steak omakase",
    times: "3",
    michelin: "*",
  },
  itaewonpocha: {
    name: "Itaewon Pocha",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://goo.gl/maps/qLopW8hECZDQkNB2A",
    rating: "7",
    price: "2",
    style: "Korean",
    text: "Korean drinking spot, would rec seafood ricecake",
    times: "3",
  },
  kimura: {
    name: "Kimura",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/9x79BuK7iVw3azEh7",
    rating: "6",
    price: "2",
    style: "Japanese",
    text: "Shabushabu with great sauces",
    times: "1",
  },
  koko: {
    name: "Koko Sushi",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/s551Ebi1zQ4aULTt6",
    rating: "3",
    price: "1",
    style: "Japanese",
    text: "AYCE sushi lol, quantity over quality",
    times: "1",
  },
  littlealley: {
    name: "Little Alley",
    location: "New York City",
    district: "Murray Hill",
    googleMaps: "https://goo.gl/maps/ywVakh2NjtBEaw26A",
    rating: "4",
    price: "1",
    style: "Chinese",
    text: "Shanghainese food, would rec Yan Du Xian",
    times: "3",
  },
  lostacosno1: {
    name: "Los Tacos No 1",
    location: "New York City",
    district: "Midtown",
    googleMaps: "https://goo.gl/maps/kFCCm9fiVjLE97ee6",
    rating: "7",
    price: "1",
    style: "Mexican",
    text: "Pricy but high quality adobada + carne asada tacos",
    times: "3",
  },
  nowon: {
    name: "Nowon",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://g.page/nowon-nyc?share",
    rating: "8",
    price: "2",
    style: "Korean",
    text: "Korean American Pocha with delicious food + drinks",
    times: "3",
  },
  pocha32: {
    name: "Pocha 32",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://g.page/Pocha32NYC?share",
    rating: "8",
    price: "2",
    style: "Korean",
    text: "Soy garlic fried chicken is the optimal drinking food",
    times: "5",
  },
  raku: {
    name: "Raku",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/HgQjwt7wg78Ec3cS7",
    rating: "8",
    price: "2",
    style: "Japanese",
    text: "Udon spot with great karaage",
    times: "3",
  },
  santambroeus: {
    name: "Sant Ambroeus",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://goo.gl/maps/g7F3vgJqqjWSYRai7",
    rating: "6",
    price: "2",
    style: "Italian",
    text: "Pasta",
    times: "1",
  },
  scampi: {
    name: "Scampi",
    location: "New York City",
    district: "Flatiron",
    googleMaps: "https://goo.gl/maps/FbbSJGW8c9mDK3aP9",
    rating: "7",
    price: "2",
    style: "Italian",
    text: "Pasta",
    times: "1",
  },
  uluh: {
    name: "Uluh",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://g.page/uluhny?share",
    rating: "8",
    price: "2",
    style: "Chinese",
    text: "Authentic Chinese food from multiple regions",
    times: "1",
  },
  wokuni: {
    name: "Wokuni",
    location: "New York City",
    district: "Murray Hill",
    googleMaps: "https://goo.gl/maps/ziKDdeC9T7ZijrtZ8",
    rating: "7",
    price: "2",
    style: "Japanese",
    text: "Super fresh fish, would rec the tempura and karaage as well.",
    times: "1",
  },
  wokwok: {
    name: "Wok Wok",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/HvJuhyqD3N29Zeyx8",
    rating: "7",
    price: "1",
    style: "Malaysian",
    text:
      "Malaysian Chinese food, would rec their salted fish egg plant stone rice",
    times: "1",
  },
  thaidiner: {
    name: "Thai Diner",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://goo.gl/maps/JqXtrkkrzVsx1i186",
    rating: "8",
    price: "1",
    style: "Thai",
    text: "Thai fusion food, big fan of their fried chicken pad see ew",
    times: "4",
  },
  abckitchen: {
    name: "ABC Kitchen",
    location: "New York City",
    district: "Flatiron",
    googleMaps: "https://goo.gl/maps/scycdjaXHvVM2Knp6",
    rating: "6",
    price: "2",
    style: "American",
    text: "Fresh modern American food, crab toast is great",
    times: "2",
  },
  atoboy: {
    name: "Atoboy",
    location: "New York City",
    district: "Nomad",
    googleMaps: "https://goo.gl/maps/2f9amt8idHJ538vD9",
    rating: "7",
    price: "3",
    style: "Korean",
    text:
      "Fine dining-esque Korean fusion tapas, prepare to be exposed to new flavors",
    times: "1",
  },
  baekjong: {
    name: "Baekjong",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://goo.gl/maps/3F5XKRkLeML3RVdo8",
    rating: "8",
    price: "2",
    style: "Korean",
    text: "High quality super tender KBBQ ",
    times: "2",
  },
  barnjoo: {
    name: "Barn Joo",
    location: "New York City",
    district: "Union Square",
    googleMaps: "https://goo.gl/maps/oD3u6nN6BxDoT8bm9",
    rating: "5",
    price: "2",
    style: "Korean",
    text: "Good drinks + Korean tapas",
    times: "2",
  },
  bbqchicken: {
    name: "BBQ Chicken",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://g.page/bbqchickenktownnyc?share",
    rating: "6",
    price: "2",
    style: "Korean",
    text: "Korean fried chicken and beer",
    times: "2",
  },
  bobwhites: {
    name: "Bobwhite Counter",
    location: "New York City",
    district: "Alphabet City",
    googleMaps: "https://g.page/BobwhiteCounter?share",
    rating: "7",
    price: "0",
    style: "American",
    text: "Buffalo Fried Chicken Sandwich + Mac",
    times: "4",
  },
  gammeok: {
    name: "Gameeok",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://g.page/BobwhiteCounter?share",
    rating: "6",
    price: "1",
    style: "American",
    text: "Traditional korean soups and food",
    times: "1",
  },
  gogocurry: {
    name: "Go Go Curry",
    location: "New York City",
    district: "Financial District",
    googleMaps: "https://goo.gl/maps/am2tgMH8VKyGurRn6",
    rating: "5",
    price: "0",
    style: "Japanese",
    text: "Fast food Japanese curry",
    times: "2",
  },
  jejunoodlebar: {
    name: "Jeju Noodle Bar",
    location: "New York City",
    district: "West Village",
    googleMaps: "https://g.page/jejunoodlebar?share",
    rating: "8",
    price: "2",
    style: "Korean",
    text: "Korean Ramyun with strong broths",
    times: "2",
    michelin: "*",
  },
  mamounsfalafel: {
    name: "Mamoun's",
    location: "New York City",
    district: "Greenwich Village",
    googleMaps: "https://g.page/MamounsGreenwichVillageManhattan?share",
    rating: "7",
    price: "0",
    style: "Mediterranean",
    text: "Fast, cheap, delicious falfel + shawarma sandwiches",
    times: "3",
  },
  nonono: {
    name: "Nonono",
    location: "New York City",
    district: "Nomad",
    googleMaps: "https://g.page/nonono-new-york?share",
    rating: "7",
    price: "2",
    style: "Japanese",
    text: "Yakitori skewers + ramen spot, Japanese Tapas",
    times: "3",
  },
  cocoron: {
    name: "Cocoron",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://goo.gl/maps/auqkFMUhPHma7YPdA",
    rating: "6",
    price: "1",
    style: "Japanese",
    text: "Japanese curry and udon spot",
    times: "1",
  },
  princest: {
    name: "Prince St Pizza",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://goo.gl/maps/nuG6WxNaHMWyXN4U9",
    rating: "7",
    price: "1",
    style: "American",
    text: "Thick crust square pizza with thick grease pool peps",
    times: "3",
  },
  shabushabumayumon: {
    name: "Shabushabu Mayumon",
    location: "New York City",
    district: "Lower East Side",
    googleMaps: "https://goo.gl/maps/ymcrSnG3rJa9RuXP9",
    rating: "10",
    price: "4",
    style: "Japanese",
    text: "Mindblowing A5 Miyazaki wagyu with assorted sauces and preparation",
    times: "1",
  },
  sushinakazawa: {
    name: "Sushi Nakazawa",
    location: "New York City",
    district: "West Village",
    googleMaps: "https://goo.gl/maps/vNXEdeY2AxFUvzc57",
    rating: "8",
    price: "4",
    style: "Japanese",
    text: "Omakase, favorites were smoked mackarel, chutoro, otoro, monkfish",
    times: "1",
    michelin: "*",
  },
  tacombi: {
    name: "Tacombi",
    location: "New York City",
    district: "Flatiron",
    googleMaps: "https://goo.gl/maps/CHRGuVtF8z4TcrQ47",
    rating: "6",
    price: "1",
    style: "Mexican",
    text: "Would rec adobada and ensenada burritos",
    times: "3",
  },
  taiwanporkchophouse: {
    name: "Taiwan Porkchop House",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/ch2t8vbQMvKD9gVp6",
    rating: "8",
    price: "0",
    style: "Taiwanese",
    text: "Would rec porkchop + rice, salt + pepper chicken",
    times: "4",
  },
  tomoesushi: {
    name: "Tomoe Sushi",
    location: "New York City",
    district: "Greenwich Village",
    googleMaps: "https://goo.gl/maps/7ZyeaqbTRifJCSe2A",
    rating: "8",
    price: "1",
    style: "Japanese",
    text: "The best non omakase sushi in NYC",
    times: "4",
    closed: true,
  },
  tonybaloneys: {
    name: "Tony Baloneys",
    location: "Jersey City",
    district: "",
    googleMaps: "https://g.page/tony-boloneys-jersey-city?share",
    rating: "4",
    price: "1",
    style: "American",
    text: "Fun pizza but really heavy ",
    times: "1",
  },
  banhmisaigon: {
    name: "Banh Mi Saigon",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/ioqVc8BEWrABLfe58",
    rating: "8",
    price: "0",
    style: "Vietnamese",
    text: "Best Banh Mi in NYC",
    times: "4",
  },
  benemon: {
    name: "Benemon",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/gkuAB145cKaaWuiE6",
    rating: "6",
    price: "1",
    style: "Japanese",
    text: "Donburi bowls and Japanese comfort food",
    times: "1",
  },
  blackseedbagels: {
    name: "Black Seed Bagels",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://g.page/blackseedbagelsnolita?share",
    rating: "7",
    price: "1",
    style: "American",
    text: "Bagel sandwiches",
    times: "1",
  },
  bricklanecurry: {
    name: "Brick Lane Curry",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://g.page/bricklanenyc?share",
    rating: "5",
    price: "2",
    style: "American",
    text: "Major hubris on phaal spice challenge but would rec",
    times: "1",
  },
  elgallotacqueria: {
    name: "El Gallo Tacqueria",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://g.page/elgallo-taqueria-nolita?share",
    rating: "7",
    price: "1",
    style: "American",
    text: "Satisfies burrito fix in NYC",
    times: "5",
  },
  houyihotpot: {
    name: "Hou Yi Hot Pot",
    location: "New York City",
    district: "Lower East Side",
    googleMaps: "https://goo.gl/maps/18zJBvprz1hMPtSTA",
    rating: "7",
    price: "1",
    style: "American",
    text: "Cheap AYCE Hot Pot",
    times: "3",
  },
  joesriceroll: {
    name: "Joe's Steamed Rice Roll",
    location: "New York City",
    district: "Lower East Side",
    googleMaps: "https://goo.gl/maps/zWqBmmJxZk4iZhuM6",
    rating: "5",
    price: "0",
    style: "Chinese",
    text: "Rice rolls",
    times: "1",
  },
  jongrobbq: {
    name: "Jongro BBQ",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://goo.gl/maps/zWqBmmJxZk4iZhuM6",
    rating: "8",
    price: "2",
    style: "Korean",
    text: "High quality super tender KBBQ, rec the goblet",
    times: "2",
  },
  lilfrankies: {
    name: "Lil Frankies",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/FAr5n66wZwH2vP997",
    rating: "7",
    price: "1",
    style: "Italian",
    text: "Cheap, simple pasta and tiramisu",
    times: "4",
  },
  loscarnalitos: {
    name: "Los Carnalitos",
    location: "Bay Area",
    district: "Hayward",
    googleMaps: "https://goo.gl/maps/NQs5BFF7DHhehh6XA",
    rating: "7",
    price: "0",
    style: "Mexican",
    text: "Al pastor is amazing here",
    times: "1",
  },
  misoya: {
    name: "Misoya",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/eYRRF8Dh4HHpDjvu5",
    rating: "6",
    price: "0",
    style: "Japanese",
    text: "Fun selection of miso flavored broth to try",
    times: "2",
  },
  miznon: {
    name: "Miznon",
    location: "New York City",
    district: "Chelsea",
    googleMaps: "https://goo.gl/maps/eYRRF8Dh4HHpDjvu5",
    rating: "6",
    price: "0",
    style: "Mediterranean",
    text: "Super unique grilled cheese pita burger",
    times: "1",
  },
  newmizusushi: {
    name: "New Mizu Sushi",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/z52bD9z2WUjLC1Gx7",
    rating: "7",
    price: "0",
    style: "Japanese",
    text: "Great cheap American-Japanese sushi",
    times: "1",
  },
  saltiegirl: {
    name: "Saltie Girl",
    location: "Boston",
    district: "",
    googleMaps: "https://goo.gl/maps/qbVRguWReyxFrTweA",
    rating: "7",
    price: "2",
    style: "American",
    text: "Super fresh oysters and seafood",
    times: "1",
  },
  shanghai21: {
    name: "Shanghai 21",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/F281UJNUbhi6QBAv6",
    rating: "7",
    price: "1",
    style: "Chinese",
    text: "Great soup dumplings, would rec salt and pepper pork chop",
    times: "1",
  },
  take31: {
    name: "Take31",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://g.page/take31nyc?share",
    rating: "8",
    price: "2",
    style: "Korean",
    text:
      "Modern Korean pub food with cozy vibes, would rec white peach Makgeolli",
    times: "5",
  },
  thaivilla: {
    name: "Thai Villa",
    location: "New York City",
    district: "Flatiron",
    googleMaps: "https://goo.gl/maps/u46azUs6MJUUkQ8z5",
    rating: "7",
    price: "1",
    style: "Thai",
    text: "Upscale Thai food served in a beautiful palace",
    times: "2",
  },
  thursdaykitchen: {
    name: "Thursday Kitchen",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://g.page/thursdaykitchen?share",
    rating: "8",
    price: "2",
    style: "Korean",
    text: "Fusion Korean tapas with strong and unique flavors",
    times: "1",
  },
  tonchin: {
    name: "Tonchin",
    location: "New York City",
    district: "Midtown",
    googleMaps: "https://g.page/tonchinnewyork?share",
    rating: "7",
    price: "1",
    style: "Japanese",
    text: "Best ramen in NYC, the tokyo pork tonkatsu is great",
    times: "4",
  },
  casalafemme: {
    name: "Casa La Femme",
    location: "New York City",
    district: "West Village",
    googleMaps: "https://goo.gl/maps/wxVXZHbpf3jSDqvn7",
    rating: "2",
    price: "2",
    style: "Egyptian",
    times: "1",
    text: "Beatifiul space",
  },
  arsimp: {
    url: "arsimp",
    name: "AR-Simp",
    location: "Bangkok",
    district: "Ratchathweri",
    googleMaps: "https://goo.gl/maps/xiPdKZAUQ5eQqXUN6",
    rating: "8",
    price: "0",
    style: "Thai",
    text:
      "Best pad thai I've had, made by a Grandma's street stall. A true explosion flavors.",
    times: "3",
  },
  supanniga: {
    url: "supanniga",
    name: "Supanniga Eating Room",
    location: "Bangkok",
    district: "Thong Lor",
    googleMaps: "https://g.page/supannigaeatingroomthonglor",
    rating: "6",
    price: "1",
    style: "Thai",
    text: "Traditional Thai food, would rec the crab curry",
    times: "1",
  },
  tuome: {
    url: "tuome",
    name: "Tuome",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/g5P1LKHuisymiDbd7",
    rating: "7",
    price: "2",
    style: "Chinese",
    michelin: "*",
    text:
      "Really enjoyed the layering of textures on the crispy pork and the lychee salad",
    times: "1",
  },
  hawkerchans: {
    url: "hawkerchan",
    name: "Hawker Chan",
    location: "Singapore",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/6fT1fSAcNUikFfm87",
    rating: "6",
    price: "0",
    style: "Chinese",
    lastVisited: "2019-01-06",
    text: "Sweet, garlicy, tender soy sauce chicken over rice",
    times: "1",
  },
  foodloft: {
    url: "foodloft",
    name: "Food Loft",
    location: "Singapore",
    district: "Geylang",
    googleMaps: "https://goo.gl/maps/VGsHEkDDLr4HpegF7",
    rating: "7",
    price: "0",
    style: "Singaporean",
    lastVisited: "2019-01-09",
    text:
      "$4 Singaporean breakfast of iced coffee, kaya toast, and soft boiled egg is so simple and so perfect",
    times: "2",
  },
  breadstreetkitchen: {
    url: "breadstreetkitchen",
    name: "Bread Street Kitchen",
    location: "Singapore",
    district: "Central",
    googleMaps: "https://goo.gl/maps/VGsHEkDDLr4HpegF7",
    rating: "8",
    price: "2",
    style: "British",
    lastVisited: "2019-01-07",
    text:
      "Gordon Ramsay's beef wellington was perfect: flaky, juicy, tender, umami",
    times: 1,
  },
  marinasouthdeliciousfood: {
    url: "marinasouthdeliciousfood",
    name: "Marina South Delicious Food",
    location: "Singapore",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/ABhwoEEhN41RAmSQ7",
    rating: "7",
    price: "0",
    style: "Singaporean",
    lastVisited: "2019-01-08",
    text:
      "Cheap, fast, delicious hawker food, would rec any noodle and oyster omelette",
    times: "1",
  },
  jumboseafood: {
    url: "jumboseafood",
    name: "Jumbo Seafood",
    location: "Singapore",
    district: "Clarke Quay",
    googleMaps: "https://goo.gl/maps/5s1PrjDx9E2kJU7N9",
    rating: "9",
    price: "2",
    style: "Singaporean",
    lastVisited: "2019-01-10",
    text:
      "Crab with an explosion of flavors from spices all over SEA. Best crab I've had.",
    times: "1",
  },
  bondisushi: {
    url: "bondisushi",
    name: "Bondi Sushi",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://goo.gl/maps/tfW9eYjCsWa2tLAG8",
    rating: "2",
    price: "1",
    style: "Japanese",
    lastVisited: "2019-01-10",
    text: "Thin sashimi, was almost fully cooked after being seared",
    times: "1",
  },
  laspalmas: {
    url: "laspalmas",
    name: "Las Palmas Pittsburgh #2",
    location: "Pittsburgh",
    district: "Oakland",
    googleMaps: "https://goo.gl/maps/TUDH19ad5HF928fY8",
    rating: "7",
    price: "0",
    style: "Mexican",
    lastVisited: "2020-03-05",
    text:
      "Delicious tacos and salsas with tortillas/meats grilled to order in front of a Mexican grocery store.",
    times: "5",
  },
  panchovilla: {
    id: 12,
    url: "panchovilla",
    name: "Pancho Villa Tacqueria",
    location: "San Francisco",
    district: "Mission",
    googleMaps: "https://goo.gl/maps/crPP1uWj9dYYdihQ9",
    rating: "7",
    price: "0",
    style: "Mexican",
    lastVisited: "2019-08-19",
    text:
      "Delicious tacos and salsas at the neighbordhood tacqueria. Favorites were carne asada, al pastor, carnitas.",
    times: "5",
  },
  latacqueria: {
    url: "latacqueria",
    name: "La Tacqueria",
    location: "San Francisco",
    district: "Mission",
    googleMaps: "https://goo.gl/maps/fJwV6jh585m9c9Vx5",
    rating: "8",
    price: "1",
    style: "Mexican",
    lastVisited: "2019-07-31",
    text:
      "Carne asada grilled burrito was the best I've had. Meat, beans, salsa, guac, and best part: no rice.",
    video: "https://www.youtube.com/watch?v=ajcJTpIh44o",
    times: "3",
  },
  tsurutontan: {
    url: "tsurutontan",
    name: "Tsurutontan Udon Brasserie",
    location: "New York City",
    district: "Union Square ",
    googleMaps: "https://goo.gl/maps/L8WvvEVRTnhtMkAy7",
    rating: "6",
    price: "1",
    style: "Japanese",
    lastVisited: "2021-03-27",
    text: "Great udon with huge portions.",
    times: "2",
  },
  katzdelicatessen: {
    name: "Katz Delicatessen",
    location: "New York City",
    district: "Lower East Side ",
    googleMaps: "https://goo.gl/maps/KmETFGs8rFqXqkza8",
    rating: "5",
    price: "1",
    style: "Jewish",
    lastVisited: "2021-04-03",
    text:
      "Great pastrami sandwiches at an iconic New York deli. Felt overhyped to me",
    video: "https://www.youtube.com/watch?v=ydQ5UZpJRls",
    times: "1",
  },
  fivespices: {
    name: "5ive Spices Taco and Banh Mi",
    location: "New York City",
    district: "Nolita ",
    googleMaps: "https://g.page/5ivespiceles?share",
    rating: "6",
    price: "1",
    style: "Vietnamese",
    text: "Great banh mi and pho spot",
    times: "1",
  },
  adegadosarcos: {
    name: "Adega Dos Arcos",
    location: "Lisbon",
    district: "",
    googleMaps: "https://g.page/5ivespiceles?share",
    rating: "8",
    price: "1",
    style: "Portuguese",
    text: "Rustic Portuguese spot, would rec grilled octopus and sangria",
    times: "3",
  },
  ahappypancake: {
    name: "A Happy Pancake",
    location: "Tokyo",
    district: "Ginza",
    googleMaps: "https://goo.gl/maps/WAkdGmBsEsfv3hyw6",
    rating: "8",
    price: "0",
    style: "Dessert",
    text: "Incredibly fluffy pancakes",
    times: "1",
  },
  baohaus: {
    name: "Baohaus",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/cNzTjHZPxKhnd5z48",
    rating: "6",
    price: "0",
    style: "Chinese",
    text: "Eddie huang's delicious gua bao spot",
    times: "1",
    closed: true,
  },
  basketbrothers: {
    name: "Basket Brothers",
    location: "Sydney",
    district: "",
    googleMaps: "https://goo.gl/maps/AVZfwJrzokNZso8D8",
    rating: "7",
    price: "0",
    style: "Australian",
    text: "Fresh and delicious Australian avo toast",
    times: "1",
  },
  candldumpling: {
    name: "C&L Dumpling House",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/hjbCXnFNWaXXWx3i6",
    rating: "6",
    price: "0",
    style: "Chinese",
    text: "Super cheap and delicious potstickers",
    times: "1",
  },
  chaya: {
    name: "Chaya",
    location: "Pittsburgh",
    district: "Squirrel Hill",
    googleMaps: "",
    rating: "6",
    price: "1",
    style: "Japanese",
    text: "Closest thing to Japanese sashimi I've had in Pittsburgh",
    times: "1",
    closed: true,
  },
  chodumplingking: {
    name: "Cho Dumpling King",
    location: "Sydney",
    district: "Haymarket",
    googleMaps: "https://goo.gl/maps/DwkKuuFvo1Khtkrk7",
    rating: "6",
    price: "0",
    style: "Chinese",
    text: "Would rec the eggplant potstickers",
    times: "1",
    closed: true,
  },
  coogeepavilion: {
    name: "Coogee Pavilion",
    location: "Sydney",
    district: "Coogee",
    googleMaps: "https://goo.gl/maps/DwkKuuFvo1Khtkrk7",
    rating: "7",
    price: "1",
    style: "Australian",
    text: "Great pizzas by the beach",
    times: "1",
  },
  dashichazukeen: {
    name: "Dashichazuke En",
    location: "Tokyo",
    district: "Narita",
    googleMaps: "https://goo.gl/maps/18vN6NUXqzyvf4oa7",
    rating: "6",
    price: "1",
    style: "Japanese",
    text: "Great seafood bowls at Narita airport",
    times: "1",
  },
  emmysquaredpizza: {
    name: "Emmy Squared Pizza",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://g.page/emmy-squared---east-village?share",
    rating: "6",
    price: "1",
    style: "American",
    text: "Thick crust detroit style pizza with a sweet sauce",
    times: "2",
  },
  fivesenses: {
    name: "Five Senses",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://g.page/FiveSensesNYC?share",
    rating: "6",
    price: "2",
    style: "Korean",
    text: "Traditional Korean soups and bbq",
    times: "3",
  },
  gyukatsumotomura: {
    name: "Gyukatsu Motomura",
    location: "Tokyo",
    district: "Akihabara",
    googleMaps: "https://goo.gl/maps/72TNKprB3BEcqETu5",
    rating: "4",
    price: "1",
    style: "Korean",
    text: "Fried beef steak, was a bit too rare/chewy for me",
    times: "1",
  },
  hernameishan: {
    name: "Her Name Is Han",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://goo.gl/maps/6g3wiFmbiiff4Vt98",
    rating: "7",
    price: "1",
    style: "Korean",
    text: "Traditional Korean food and soups with modern influences",
    times: "2",
  },
  hojiak: {
    name: "Ho Jiak",
    location: "Sydney",
    district: "Haymarket",
    googleMaps: "https://goo.gl/maps/6g3wiFmbiiff4Vt98",
    rating: "8",
    price: "1",
    style: "Malaysian",
    text: "Amazing Nyonya food, would rec nasi lemak and char kway teow",
    times: "2",
  },
  honmuraan: {
    name: "Honmura An",
    location: "Tokyo",
    district: "Roppongi",
    googleMaps: "https://g.page/googlebusiness120834657?share",
    rating: "6",
    price: "0",
    style: "Japanese",
    text: "Freshly made code soba with dipping broth",
    times: "1",
  },
  ichiran: {
    name: "Ichiran",
    location: "Tokyo",
    district: "Shibuya",
    googleMaps: "https://goo.gl/maps/yEvN9RJQaAyWw9qt6",
    rating: "8",
    price: "1",
    style: "Japanese",
    text: "Solo ramen spot with delicious broth and perfect noodle texture",
    times: "1",
  },
  jayakarta: {
    name: "Jayakarta",
    location: "Berkeley",
    district: "Downtown",
    googleMaps: "https://goo.gl/maps/MjfiWrDUuHfrwiJu5",
    rating: "7",
    price: "0",
    style: "Indonesian",
    text:
      "One of my first exposures to south east asian food, amazing spicy mie tek-tek noodles and nasi lemak ",
    times: "3",
    closed: true,
  },
  jiromaru: {
    name: "Jiromaru",
    location: "Tokyo",
    district: "Akihabara",
    googleMaps: "https://g.page/jiromaru-akihabara?share",
    rating: "7",
    price: "2",
    style: "Japanese",
    text: "Yakiniku with great meat (A5 wagyu) at an affordable price",
    times: "2",
  },
  lankanfillingstation: {
    name: "Lankan Filling Station",
    location: "Sydney",
    district: "Darlinghurst",
    googleMaps: "https://goo.gl/maps/4o67MRzjC59PixaM9",
    rating: "6",
    price: "1",
    style: "Sri Lankan",
    text: "Unique and strong flavored curries with great lattice hoppers",
    times: "1",
  },
  laut: {
    name: "Laut",
    location: "New York City",
    district: "Union Square",
    googleMaps: "https://goo.gl/maps/LjWoJj5a6SQYkCho9",
    rating: "6",
    price: "2",
    style: "Malaysian",
    text: "Unique laksa with tons of flavors",
    times: "1",
  },
  malaproject: {
    name: "Mala Project",
    location: "New York City",
    district: "East Village",
    googleMaps: "https://goo.gl/maps/qaozofQqJsitLPDT6",
    rating: "7",
    price: "1",
    style: "Chinese",
    text: "Spicy and numbing dry pot with a ton of flavors",
    times: "5",
  },
  meetfresh: {
    name: "Meet Fresh",
    location: "Bay Area",
    district: "Fremont",
    googleMaps: "https://goo.gl/maps/K2HGJH6f1kdkbTCq5",
    rating: "7",
    price: "1",
    style: "Dessert",
    text: "Great ice, tea, and taiwanese dessert ",
    times: "4",
  },
  momosan: {
    name: "Momosan Ramen",
    location: "New York City",
    district: "Murray Hill",
    googleMaps: "https://goo.gl/maps/rq6NMp5GtqEMrVxu8",
    rating: "6",
    price: "1",
    style: "Japanese",
    text: "Ramen from an iron chef, would rec the curry ramen",
    times: "1",
  },
  mosburger: {
    name: "Mos Burger",
    location: "Tokyo",
    district: "Akihabara",
    googleMaps: "https://goo.gl/maps/2eP6oRxXDsjPyhCP7",
    rating: "5",
    price: "0",
    style: "American",
    text: "Popular burger spot in Asia, meat was sausage-esque",
    times: "1",
  },
  mrmengchongqinggourmet: {
    name: "Mr Meng Chongqing Gourmet",
    location: "Sydney",
    district: "Haymarket",
    googleMaps: "https://goo.gl/maps/bWD6H7H7PTSqJN4C8",
    rating: "6",
    price: "0",
    style: "Chinese",
    text:
      "Sichuan noodle spot from the Meng Fei, the host of the popular Chinese Dating show",
    times: "1",
  },
  nemurohanamaru: {
    name: "Nemuro Hanamaru",
    location: "Tokyo",
    district: "Ginza",
    googleMaps: "https://goo.gl/maps/VyainrXfEicHjt4q9",
    rating: "9",
    price: "2",
    style: "Japanese",
    text:
      "Amazingly fresh sushi train, every piece from their wide selection was fantastic",
    times: "2",
  },
  newmalaysia: {
    name: "West New Malaysia",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/JEgz7oP6aFE4b5rv5",
    rating: "6",
    price: "1",
    style: "Malysian",
    text:
      "Cheap and delicious Malaysian curries and noodles with large portions",
    times: "2",
  },
  ootoya: {
    name: "Ootoya",
    location: "New York City",
    district: "Flatiron",
    googleMaps: "https://goo.gl/maps/KE3ikk9Jd5ywHqh48",
    rating: "8",
    price: "1",
    style: "Japanese",
    text:
      "Love their miso tonkatsu don, fried pork cutlet covered in a strong miso gravy",
    times: "5",
  },
  pelicana: {
    name: "Pelicana",
    location: "New York City",
    district: "Koreatown",
    googleMaps: "https://goo.gl/maps/NM2is8F7vCVb62wr5",
    rating: "6",
    price: "1",
    style: "Korean",
    text: "Korean fried chicken",
    times: "2",
  },
  pizzahutjp: {
    name: "Pizza Hut Japan",
    location: "Tokyo",
    district: "",
    googleMaps: "https://goo.gl/maps/yvTZmznfMhA1Ww378",
    rating: "6",
    price: "1",
    style: "Japanese",
    text:
      "Kalbi pizza was uprisingly really good, sausage crust is a gamechanger",
    times: "1",
  },
  rokurinsha: {
    name: "Rokurinsha",
    location: "Tokyo",
    district: "Ginza",
    googleMaps: "https://goo.gl/maps/a8uvuHE4BUw4Cgm47",
    rating: "9",
    price: "1",
    style: "Japanese",
    text:
      "Umami bomb dipping ramen, noodles were springy, perfect egg, rich broth",
    times: "1",
  },
  roseteacafe: {
    name: "Rose Tea Cafe",
    location: "Pittsburgh",
    district: "Oakland",
    googleMaps: "https://g.page/RoseTeaExpress?share",
    rating: "7",
    price: "0",
    style: "Chinese",
    text: "Great fried chicken and sausage rice bowls",
    times: "4",
  },
  saintpeter: {
    name: "Saint Peter",
    location: "Sydney",
    district: "Paddington",
    googleMaps: "https://goo.gl/maps/kSksAS2uQCWWmZdNA",
    rating: "10",
    price: "4",
    style: "Australian",
    text:
      "Incredible seafood featuring dry aged fish grilled on charcoal, scallops, grilled octopus and enoki mushroom, and oysters",
    times: "1",
  },
  seveneleven: {
    name: "Seven Eleven Japan",
    location: "Tokyo",
    district: "",
    googleMaps: "",
    rating: "7",
    price: "0",
    style: "Japanese",
    text:
      "7/11 is insane in Japan with snacks, drinks, bentos, and more. Would rec fruit cream custard sandos",
    times: "3",
  },
  shinyokohamaramenmuseum: {
    name: "Shin Yokohama Ramen Museum",
    location: "Tokyo",
    district: "Shin-Yokohama",
    googleMaps: "https://goo.gl/maps/Cj6dgiy25Ng5AuaQ7",
    rating: "6",
    price: "1",
    style: "Japanese",
    text: "Ramen museum featuring ramen from all of Japan",
    times: "1",
  },
  soccarat: {
    name: "Socarrat Paella Bar",
    location: "New York City",
    district: "Nolita",
    googleMaps: "https://goo.gl/maps/wcVrqt2kEw6s9rkG6",
    rating: "5",
    price: "1",
    style: "Spanish",
    text: "Went for boozy brunch",
    times: "1",
  },
  supertaste: {
    name: "Super Taste",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/6osqLnCL6tKpuD6V9",
    rating: "6",
    price: "1",
    style: "Chinese",
    text: "Cheap, fast, great noodles and pork bun gua baos",
    times: "1",
  },
  soulfoodmanakorn: {
    name: "Soul Food Mahanakorn",
    location: "Bangkok",
    district: "Thong Lor",
    googleMaps: "https://goo.gl/maps/6osqLnCL6tKpuD6V9",
    rating: "7",
    price: "1",
    style: "Thai",
    text: "Traditional Thai food, enjoyed the crab curry and roasted fish",
    times: "1",
    closed: true,
  },
  sushirio: {
    name: "Sushirio",
    location: "Sydney",
    district: "",
    googleMaps: "https://goo.gl/maps/6HkQgNsJCkUA938DA",
    rating: "7",
    price: "1",
    style: "Japanese",
    text: "Sushi train spot with fresh sashimi, would rec the scallops",
    times: "1",
  },
  sweetmoment: {
    name: "Sweet Moment",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/kM7XW4sHz5sfzjj69",
    rating: "8",
    price: "0",
    style: "Dessert",
    text: "Love their milk shaved ice, mango cheesecake one is great",
    times: "4",
  },
  tastyhandpullednoodles: {
    name: "Tasty Hand Pulled Noodles",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/cRdU6faAobB4DyT9A",
    rating: "6",
    price: "0",
    style: "Chinese",
    text: "Would rec their noodle soups",
    times: "3",
  },
  tempurahisago: {
    name: "Tempura Hisago",
    location: "Tokyo",
    district: "Akihabara",
    googleMaps: "https://g.page/akihabaratempura?share",
    rating: "8",
    price: "1",
    style: "Japanese",
    text: "Cozy tempura spot, tempura is super light and extra crispy",
    times: "1",
  },
  tigersugar: {
    name: "Tiger Sugar",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://g.page/tiger-sugar-chinatown?share",
    rating: "6",
    price: "0",
    style: "Dessert",
    text: "Brown sugar milk tea was great but bit too heavy for me.",
    times: "1",
  },
  tokyofoodshow: {
    name: "Tokyo Food Show",
    location: "Tokyo",
    district: "Shibuya",
    googleMaps: "https://goo.gl/maps/jsBXasFuX2b8tmWe7",
    rating: "7",
    price: "1",
    style: "Japanese",
    text:
      "Multiple floors of food court with all sorts of bento boxes. Sushi box was fantastic quality",
    times: "1",
  },
  tokyostationyakiudon: {
    name: "Tokyo Station Yakiudon",
    location: "Tokyo",
    district: "Ginza",
    googleMaps: "",
    rating: "7",
    price: "1",
    style: "Japanese",
    text:
      "Didn't get the name since we randomly walked in. Stir fried udon was charred perfectly",
    times: "1",
  },
  tonkatsumarugo: {
    name: "Tonkatsu Marugo",
    location: "Tokyo",
    district: "Akihabara",
    googleMaps: "https://goo.gl/maps/7TjRbkEc8gpMxRTz8",
    rating: "9",
    price: "1",
    style: "Japanese",
    text: "Crispy, juicy, tender fried pork cutlet, best tonkatsu I've had",
    times: "1",
  },
  tselogs: {
    name: "Tselogs",
    location: "San Francisco",
    district: "Mission",
    googleMaps: "https://goo.gl/maps/hkwKgTPJ9eaZXA9K7",
    rating: "6",
    price: "0",
    style: "Filipino",
    text: "Would rec the lumpia",
    times: "1",
  },
  uogashi: {
    name: "Uogashi",
    location: "New York City",
    district: "Hells Kitchen",
    googleMaps: "https://g.page/uogashi?share",
    rating: "7",
    price: "0",
    style: "Japanese",
    text: "High quality sushi with excellent presentation and service",
    times: "1",
  },
  wahfung: {
    name: "Wah Fung Fast Food",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/H2z9Ji9vGCnuoEpr8",
    rating: "7",
    price: "0",
    style: "Chinese",
    text: "A Chinatown institution, great roast pork over rice",
    times: "1",
  },
  yunshang: {
    name: "Yunshang",
    location: "New York City",
    district: "Chinatown",
    googleMaps: "https://goo.gl/maps/WnFAtVKuKrLUyDBV6",
    rating: "6",
    price: "0",
    style: "Chinese",
    text: "Rice noodle spot, curry broth was great",
    times: "1",
  },
  birite: {
    name: "Birite Creamery",
    location: "San Francisco",
    district: "Mission",
    googleMaps: "https://goo.gl/maps/Mj2a5HeuBnNjPov56",
    rating: "7",
    price: "0",
    style: "Dessert",
    text: "Specialty seasonal ice creams right next to Dolores Park",
    times: "3",
  },
  cactusmexicanfood: {
    name: "Cactus Taquerias #1",
    location: "Los Angeles",
    district: "",
    googleMaps: "https://goo.gl/maps/FUPuaJwcexoRyZqo7",
    rating: "7",
    price: "0",
    style: "Mexican",
    text: "Cheap, great tacos, loved the carne asada",
    times: "1",
  },
  countryway: {
    name: "Country Way",
    location: "Bay Area",
    district: "Fremont",
    googleMaps: "https://goo.gl/maps/TRWvz6fp9s781fNUA",
    rating: "7",
    price: "1",
    style: "American",
    text:
      "Absolute banger American diner, would country fried steak for breakfast",
    times: "3",
  },
  dandelionchocolate: {
    name: "Dandelion Chocolate",
    location: "San Francisco",
    district: "Mission",
    googleMaps: "https://goo.gl/maps/V8FLgUg5s9V7hpuf6",
    rating: "7",
    price: "0",
    style: "Dessert",
    text: "Unique chocolate tasting, would rec hot chocolate",
    times: "3",
  },
  eggslut: {
    name: "Eggslut",
    location: "Los Angeles",
    district: "",
    googleMaps: "https://goo.gl/maps/5JRF1XBVtb15HobVA",
    rating: "3",
    price: "0",
    style: "American",
    text: "Long lines, down to make at home",
    times: "1",
  },
  everydaynoodles: {
    name: "Everyday Noodles",
    location: "Pittsburgh",
    district: "Squirrel Hill",
    googleMaps: "https://g.page/EverydayNoodles?share",
    rating: "7",
    price: "1",
    style: "Chinese",
    text: "Really tasty XLB and noodle soups!",
    times: "3",
  },
  gauchoparilla: {
    name: "Gaucho Parilla Argentina",
    location: "Pittsburgh",
    district: "Downtown",
    googleMaps: "https://g.page/eatgaucho?share",
    rating: "8",
    price: "2",
    style: "Argentinian",
    text:
      "Wood fire grilled steaks with assorted house sauces, big fan of the chimichurri",
    times: "2",
  },
  guisados: {
    name: "Guisados",
    location: "Los Angeles",
    district: "",
    googleMaps: "https://goo.gl/maps/fahN4kzh9WW16ZT97",
    rating: "8",
    price: "1",
    style: "Mexican",
    text:
      "Taco spot specializing in stewed meats, favorites were birria and cabeza",
    times: "1",
  },
  inoodle: {
    name: "iNoodle",
    location: "Pittsburgh",
    district: "",
    googleMaps: "https://goo.gl/maps/J66xo51NSrL3nMZY7",
    rating: "7",
    price: "0",
    style: "Chinese",
    text:
      "Literally a meme at CMU but the fried chicken + sweet chili sauce was delicious. Japanese curry, steamed fish, eggplant, veggies were great too.",
    times: "5",
  },
  italianhomemade: {
    name: "Italian Homemade",
    location: "San Francisco",
    district: "",
    googleMaps: "https://goo.gl/maps/tMXCidn76Y2Jc7HR7",
    rating: "8",
    price: "1",
    style: "Italian",
    text:
      "Love their lasagna and pastas, their bolognese is so incredibly meaty and umami. Big fan of their tiramisu too.",
    times: "5",
  },
  laburdick: {
    name: "L.A. Burdick Handmade Chocolates",
    location: "Boston",
    district: "",
    googleMaps: "https://goo.gl/maps/PFHmhQeRuPbdVcf59",
    rating: "7",
    price: "1",
    style: "Dessert",
    text: "Would rec their hot chocolate.",
    times: "1",
  },
  lavics: {
    name: "La Victoria Tacqueria",
    location: "Bay Area",
    district: "Hayward",
    googleMaps: "https://goo.gl/maps/TcmopSWZ1snnuxDQ8",
    rating: "7",
    price: "1",
    style: "Mexican",
    text:
      "Big fan of al pastor super burrito, their orange sauce is incredibly addicting",
    times: "5",
  },
  levain: {
    name: "Levain Bakery",
    location: "New York City",
    district: "Upper West Side",
    googleMaps: "https://goo.gl/maps/NsvMrsxP6EQ9u2LB9",
    rating: "7",
    price: "0",
    style: "Dessert",
    text:
      "Giant cookie with crispy edges, cookie dough like gooey inside. Would rec chocolate walnut cookie",
    times: "3",
  },
  missionchinesefood: {
    name: "Mission Chinese Food",
    location: "San Francisco",
    district: "Mission",
    googleMaps: "https://goo.gl/maps/pQsAJJYjzAmuH9ie8",
    rating: "7",
    price: "1",
    style: "Chinese",
    text:
      "Chinese fusion, would rec thrice cooked bacon rice cakes and Chongqing chili wings",
    times: "1",
  },
  nara: {
    name: "Nara",
    location: "San Francisco",
    district: "Mission",
    googleMaps: "https://goo.gl/maps/zujaJM2wstiriZzH7",
    rating: "7",
    price: "1",
    style: "Japanese",
    text: "Delicious fresh sashimi with unique sushi combination",
    times: "1",
  },
  noodlehead: {
    name: "Noodlehead",
    location: "Pittsburgh",
    district: "",
    googleMaps: "https://goo.gl/maps/PFSE12LqejNY4xUP6",
    rating: "7",
    price: "0",
    style: "Thai",
    text:
      "Thai street food noodle spot, would rec pad see ew and chiang mai curry, their spice is spicy!",
    times: "5",
  },
  orientexpress: {
    name: "Orient Express",
    location: "Pittsburgh",
    district: "",
    googleMaps: "https://goo.gl/maps/XrCMykb4BZmugzkf6",
    rating: "5",
    price: "0",
    style: "Chinese",
    text: "Fast chinese-american food, would rec chow fun and general tso's.",
    times: "4",
  },
  pamelas: {
    name: "Pamelas P&G Diner",
    location: "Pittsburgh",
    district: "",
    googleMaps: "https://goo.gl/maps/gWznWJGmbJagSP2w7",
    rating: "7",
    price: "0",
    style: "American",
    text: "Diner with fluffy crepe-style pancakes with crispy edges",
    times: "4",
  },
  pepperlunch: {
    name: "Pepper Lunch",
    location: "Bay Area",
    district: "Milpitas",
    googleMaps: "https://goo.gl/maps/ibMJbrCXwj9ZJkns7",
    rating: "6",
    price: "0",
    style: "Japanese",
    text: "Steak and rice sizzling plate",
    times: "1",
  },
  sliver: {
    name: "Sliver",
    location: "Berkeley",
    district: "",
    googleMaps: "https://goo.gl/maps/wjJEr2wQzdav2pN18",
    rating: "7",
    price: "0",
    style: "American",
    text:
      "Amazing vegeterian pizza spot that does one unique pizza a day, love their green sauce",
    times: "4",
  },
  snowcrave: {
    name: "Sno-Crave Tea House",
    location: "Bay Area",
    district: "Fremont",
    googleMaps: "https://goo.gl/maps/A7EpAAH5V9SAutdq5",
    rating: "6",
    price: "0",
    style: "Dessert",
    text: "Great teas / boba, would not rec the golden toast",
    times: "3",
  },
  sugarfish: {
    name: "Sugarfish by sushi nozawa",
    location: "New York City",
    district: "Flatiron",
    googleMaps: "https://goo.gl/maps/cpkZGTzGTMvWnrwc7",
    rating: "7",
    price: "2",
    style: "Japanese",
    text:
      "Trust me provides an affordable multi course sushi experience with great fish, but a little strongly seasoned.",
    times: "4",
  },
  supertaco: {
    name: "Super Taco",
    location: "Bay Area",
    district: "Fremont",
    googleMaps: "https://goo.gl/maps/pjziTbm1B8RNonwo7",
    rating: "7",
    price: "0",
    style: "Mexican",
    text: "Carne asada super burrito with loads of green sauce.",
    times: "4",
  },
  sushifuku: {
    name: "Sushi Fuku",
    location: "Pittsburgh",
    district: "Oakland",
    googleMaps: "https://goo.gl/maps/kHZiBHsXBAW28m2e8",
    rating: "5",
    price: "0",
    style: "Japanese",
    text: "American style sushi",
    times: "3",
  },
  tacquerialoscoyotes: {
    name: "Tacqueria Los Coyotes",
    location: "San Francisco",
    district: "Mission",
    googleMaps: "https://goo.gl/maps/imBTbiqG8hW6ewmR8",
    rating: "5",
    price: "0",
    style: "Mexican",
    text: "Tacos",
    times: "1",
  },
  tongfongfattchicken: {
    name: "Tong Fong Fatt Hainanese Boneless Chicken Rice",
    location: "Singapore",
    district: "",
    googleMaps: "https://goo.gl/maps/xRtLZMo46g2yoJet6",
    rating: "6",
    price: "0",
    style: "Singaporean",
    text: "Hainanese Chicken rice",
    times: "1",
  },
  yuki: {
    name: "Yuki Japanese Restaurant",
    location: "Bay Area",
    district: "Fremont",
    googleMaps: "https://goo.gl/maps/pSoYg3u4gLKzpYni9",
    rating: "6",
    price: "0",
    style: "Japanese",
    text: "Cozy Japanese food",
    times: "1",
  },
  zennoodle: {
    name: "Zen Noodle House",
    location: "Pittsburgh",
    district: "Oakland",
    googleMaps: "https://goo.gl/maps/heHW4WTytUAprgkZ6",
    rating: "6",
    price: "1",
    style: "Japanese",
    text: "Great ramen in Pittsburgh, would rec shoyu",
    times: "4",
  },
  porch: {
    name: "The Porch at Schenley",
    location: "Pittsburgh",
    district: "Oakland",
    googleMaps: "https://goo.gl/maps/Kkpb145MY5XFbqLZ9",
    rating: "7",
    price: "1",
    style: "American",
    text: "Great half off pizza on weekday nights",
    times: "4",
  },
};

let id = 0;
for (let i = 0; i < restaurants.length; i++) {
  const place = restaurants[i];
  const key = Object.keys(place)[0];
  place[key]["id"] = id;
  id += 1;
  restaurants[key] = place[key];
}

export default restaurants;
